// bao migrate skip
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ConfigurationItemAuditDialog from "./../../factories/configuration-item-audit-dialog";
import BaoRouter from "./../../services/bao-router";
function ConfigurationItemDiaryDialog(tabPage, parent) {
    var self = this;
    self.ConfigurationItem = parent.ConfigurationItem;
    var _deleteMessageRefDocument = Bao.Session.GetMessage("msgDeleteConfigurationItemDiaryReferenceDocument");
    self.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
    self.Dialog.Width("750px");
    self.Dialog.Buttons([{
            Title: Bao.Session.GetMessage("msgOk"),
            Click: function () {
                if (!self.ValidateDialog()) {
                    return;
                }
                self.DialogResult("ok");
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }, {
            Title: Bao.Session.GetMessage("msgCancel"),
            Click: function () {
                self.Dialog.Close();
            },
            Enabled: ko.observable(true)
        }]);
    self.DialogViewModel = {};
    self.DialogViewModel.Bao = Bao;
    self.DialogResult = ko.observable();
    self.DialogViewModel.TotalRows = ko.observable();
    self.DialogViewModel.PageIndex = ko.observable(0);
    self.DialogViewModel.PageSize = ko.observable(20);
    self.DialogViewModel.DiaryDocumentCollection = ko.observableArray();
    self.DialogViewModel.SelectedDiaryReferenceDocumentRow = ko.observable();
    self.DialogViewModel.DiaryReferenceDocumentButtons = ko.observableArray();
    self.DialogViewModel.SortingDiaryReferenceDocument = ko.observableArray();
    self.DialogViewModel.ToolbarButtons = ko.observableArray([]);
    self.DialogViewModel.CustomerFilterId = ko.observable();
    self.DialogViewModel.ToolbarButtons.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.SelectedDiaryReferenceDocumentRow.subscribe(function () {
        self.DialogViewModel.ToggleToolbarButtons();
    });
    self.DialogViewModel.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemDiaryReferenceDocumentCollection", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: parent.ConfigurationItem.ConfigurationItemId(),
            configurationItemDiaryId: self.DialogViewModel.ConfigurationItemDiaryId(),
            pageIndex: self.DialogViewModel.PageIndex(),
            pageSize: self.DialogViewModel.PageSize(),
            sorting: self.DialogViewModel.SortingDiaryReferenceDocument()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.DialogViewModel.SelectedDiaryReferenceDocumentRow(null);
            self.DialogViewModel.TotalRows(0);
            self.DialogViewModel.DiaryDocumentCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.DialogViewModel.DiaryDocumentCollection(searchResult.Models);
                self.DialogViewModel.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.DialogViewModel.DownloadConfigurationItemDiaryReferenceDocument = function (configurationItemDiaryId, configurationItemDiaryReferenceDocumentId) {
        window.open(Bao.Content("ConfigurationItemTab/DownloadDiaryReferenceDocument?configurationItemDiaryReferenceDocumentId=" + configurationItemDiaryReferenceDocumentId
            + "&sessionTabId=" + parent.ConfigurationItem.TabPage.SessionTabId + "&configurationItemDiaryId=" + configurationItemDiaryId));
    };
    self.DialogViewModel.ToggleToolbarButtons = function () {
        ko.utils.arrayForEach(self.DialogViewModel.ToolbarButtons(), function (button: any) {
            switch (button.ActionKey()) {
                case "ConfigurationItemDiaryReferenceDocumentEdit":
                case "ConfigurationItemDiaryReferenceDocumentRemove":
                case "ConfigurationItemDiaryReferenceDocumentExport":
                    button.Enabled(!(self.DialogViewModel.SelectedDiaryReferenceDocumentRow() == null));
                    break;
            }
        });
    };
    self.DialogViewModel.GetFirstSelectedId = function () {
        if (ko.unwrap(self.DialogViewModel.SelectedDiaryReferenceDocumentRow()) != null) {
            return ko.unwrap(self.DialogViewModel.SelectedDiaryReferenceDocumentRow().ConfigurationItemDiaryReferenceDocumentId);
        }
        return null;
    };
    self.DialogViewModel.AuditTrail = function () {
        var auditDialog = null;
        if (self.DialogViewModel.GetFirstSelectedId() !== null) {
            auditDialog = new ConfigurationItemAuditDialog(self.DialogViewModel.GetFirstSelectedId(), ko.unwrap(tabPage.Title), tabPage, "ConfigurationItemTab/CreateAuditTrailDiaryReferenceDocument");
        }
        else {
            auditDialog = new ConfigurationItemAuditDialog(self.DialogViewModel.ConfigurationItemDiaryId(), ko.unwrap(tabPage.Title), tabPage, "ConfigurationItemTab/CreateAuditTrailOverviewDiaryReferenceDocument", true);
        }
        auditDialog.Open();
    };
    self.DialogViewModel.AddConfigurationItemDiaryReferenceDocument = function (model, configurationItemDiaryId) {
        tabPage.IsLoading(true);
        if (model.IsDocumentNew() == true) {
            self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() + 1);
        }
        Bao.post("ConfigurationItemTab/AddConfigurationItemDiaryReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            diaryReferenceDocumentModel: ko.map.toJS(model),
            configurationItemDiaryId: configurationItemDiaryId
        }), function () {
            parent.ConfigurationItem.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.DeleteConfigurationItemDiaryReferenceDocument = function (configurationItemDiaryId, configurationItemDiaryReferenceDocumentId) {
        self.DialogViewModel.DocumentCount(self.DialogViewModel.DocumentCount() - 1);
        return Bao.post("ConfigurationItemTab/DeleteConfigurationItemDiaryReferenceDocument", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemDiaryId: configurationItemDiaryId,
            configurationItemDiaryReferenceDocumentId: configurationItemDiaryReferenceDocumentId
        }), function () {
            parent.ConfigurationItem.TabPage.DirtyFlag(true);
            self.DialogViewModel.RefreshGrid();
        });
    };
    self.DialogViewModel.EditConfigurationItemDiaryReferenceDocument = function (configurationItemDiaryId, configurationItemDiaryReferenceDocumentId) {
        self.DialogViewModel.ShowConfigurationItemDiaryReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), configurationItemDiaryId, configurationItemDiaryReferenceDocumentId);
    };
    self.DialogViewModel.ShowConfigurationItemDiaryReferenceDocumentDialog = function (configurationItemId, configurationItemDiaryId, configurationItemDiaryReferenceDocumentId) {
        window.baorequire(["ViewModels/Dialogs/ConfigurationItemDiaryReferenceDocumentDialog"], function (vm) {
            var dialog = new vm(tabPage, parent);
            dialog.Show(configurationItemId, configurationItemDiaryId, configurationItemDiaryReferenceDocumentId);
            dialog.DialogResult.subscribe(function (dialogResult) {
                if (dialogResult == "ok") {
                    self.DialogViewModel.AddConfigurationItemDiaryReferenceDocument(dialog.DialogViewModel, self.DialogViewModel.ConfigurationItemDiaryId());
                }
            });
        });
    };
    self.DialogViewModel.toolbarDocumentClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemDiaryReferenceDocumentAdd":
                self.DialogViewModel.ShowConfigurationItemDiaryReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), self.DialogViewModel.ConfigurationItemDiaryId(), null);
                break;
            case "ConfigurationItemDiaryReferenceDocumentEdit":
                if (self.DialogViewModel.SelectedDiaryReferenceDocumentRow() != null) {
                    self.DialogViewModel.ShowConfigurationItemDiaryReferenceDocumentDialog(parent.ConfigurationItem.ConfigurationItemId(), self.DialogViewModel.ConfigurationItemDiaryId(), self.DialogViewModel.SelectedDiaryReferenceDocumentRow().OpenData);
                }
                break;
            case "ConfigurationItemDiaryReferenceDocumentRemove":
                var yesNoDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, _deleteMessageRefDocument, "yesno");
                yesNoDialog.DialogResult.subscribe(function (result) {
                    if (result === true) {
                        self.DialogViewModel.DeleteConfigurationItemDiaryReferenceDocument(self.DialogViewModel.ConfigurationItemDiaryId(), self.DialogViewModel.SelectedDiaryReferenceDocumentRow().OpenData);
                    }
                });
                break;
            case "ConfigurationItemDiaryReferenceDocumentExport":
                if (self.DialogViewModel.SelectedDiaryReferenceDocumentRow() != null) {
                    self.DialogViewModel.DownloadConfigurationItemDiaryReferenceDocument(self.DialogViewModel.ConfigurationItemDiaryId(), self.DialogViewModel.SelectedDiaryReferenceDocumentRow().OpenData);
                }
                break;
            case "ConfigurationItemDiaryReferenceDocumentAuditTrail":
                self.DialogViewModel.AuditTrail();
                break;
        }
    };
    self.DialogViewModel.ConfigurationItemDiaryCategoryId = ko.observable();
    self.DialogViewModel.PersonId = ko.observable();
    self.ValidateDialog = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.DialogViewModel.DiaryDateJs())) {
            isComplete = false;
        }
        if (self.DialogViewModel.PersonId() == null) {
            isComplete = false;
        }
        if (isComplete == false) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.GetCustomerId = function () {
        if (self.ConfigurationItem != null) {
            if (self.ConfigurationItem.ConfigurationItemTypeCategoryKey() == "Customer") {
                return self.ConfigurationItem.ConfigurationItemId();
            }
            return self.ConfigurationItem.CustomerId();
        }
        return null;
    };
    self.Show = function (configurationItemId, configurationItemDiaryId) {
        tabPage.IsLoading(true);
        Bao.post("ConfigurationItemTab/ShowConfigurationItemDiaryDialog", JSON.stringify({
            sessionTabId: parent.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: configurationItemId,
            configurationItemDiaryId: configurationItemDiaryId
        }), function (value) {
            ko.map.fromJS(value.Model, self.DialogViewModel, ko.dirtyFlag());
            self.DialogViewModel.CustomerFilterId(self.GetCustomerId());
            self.DialogViewModel.RefreshGrid();
            self.Dialog.ViewModel(self.DialogViewModel);
            self.Dialog.Template(value.Message);
            self.Dialog.Open();
            tabPage.IsLoading(false);
        });
    };
}
export default ConfigurationItemDiaryDialog;